import { render, staticRenderFns } from "./RentEdit.vue?vue&type=template&id=0bcd3ca2&scoped=true"
import script from "./RentEdit.vue?vue&type=script&lang=js"
export * from "./RentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcd3ca2",
  null
  
)

export default component.exports